import EnterpriseComponent from "../EnterpriseComponent";
import MemoryContext from "../../../util/MemoryContext";

class SortEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        this.fetchEnterpriseComponentSuccess(MemoryContext.components[`PlatformSort-${this.getName()}`], page, pageSize);
    };
}

export default SortEnterpriseComponent;